/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";

// import DashboardView from "./views/Dashboard";
import PrivateLayout from "./layouts/Private";
// import DashboardLayout from "./layouts/Dashboard";
import LoginLayout from "./layouts/Login";
import RedirectApp from "./layouts/RedirectApp";

const routes = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/login" />,
  },
  {
    path: "/auth/login",
    exact: true,
    component: () => {
      window.location = "/authenticator";
      return null;
    },
  },
  {
    path: "/dispatcher",
    exact: true,
    component: () => {
      window.location = "/dispatcher";
      return null;
    },
  },
  {
    path: "/dominos",
    exact: true,
    component: () => {
      window.location = "/dominos";
      return null;
    },
  },
  // {
  //   path: "/errors",
  //   component: DashboardLayout,
  //   routes: [
  //     {
  //       path: "/errors/error-401",
  //       exact: true,
  //       component: Error401,
  //     },
  //     {
  //       path: "/errors/error-403",
  //       exact: true,
  //       component: Error403,
  //     },
  //     {
  //       path: "/errors/error-404",
  //       exact: true,
  //       component: Error404,
  //     },
  //     {
  //       path: "/errors/error-500",
  //       exact: true,
  //       component: Error500,
  //     },
  //   ],
  // },
  {
    path: "/temjob",
    component: RedirectApp,
    routes: [
      {
        path: "/temjob/:url",
        exact: true,
        component: lazy(() => import("views/RedirectApp")),
      },
    ],
  },
  {
    path: "/login",
    component: LoginLayout,
    routes: [
      {
        path: "/login",
        exact: true,
        component: lazy(() => import("views/Login")),
      },
    ],
  },
  {
    path: "/newpassword",
    component: LoginLayout,
    routes: [
      {
        path: "/newpassword",
        exact: true,
        component: lazy(() => import("views/NewPassword")),
      },
    ],
  },
  {
    path: "/recoverpassword",
    component: LoginLayout,
    routes: [
      {
        path: "/recoverpassword",
        exact: true,
        component: lazy(() => import("views/RecoverPassword")),
      },
    ],
  },
  {
    path: "/checktoken",
    component: LoginLayout,
    routes: [
      {
        path: "/checktoken",
        exact: true,
        component: lazy(() => import("views/CheckToken")),
      },
    ],
  },
  {
    route: "*",
    component: PrivateLayout,
    routes: [
      // {
      //   path: "/dashboards",
      //   exact: true,
      //   component: PrivateLayout,
      // },
      {
        path: "/dashboards",
        exact: true,
        component: lazy(() => import("views/Dashboard")),
      },
      {
        path: "/profiles/list",
        exact: true,
        component: lazy(() => import("views/Profile/List")),
      },
      {
        path: "/profiles/edit",
        exact: true,
        component: lazy(() => import("views/Profile/Edit")),
      },
      {
        path: "/profiles/edit/:id",
        exact: true,
        component: lazy(() => import("views/Profile/Edit")),
      },
      {
        path: "/profiles/edit/:id/:clone",
        exact: true,
        component: lazy(() => import("views/Profile/Edit")),
      },
      {
        path: "/users/list",
        exact: true,
        component: lazy(() => import("views/User/List")),
      },
      {
        path: "/users/edit",
        exact: true,
        component: lazy(() => import("views/User/Edit")),
      },
      {
        path: "/users/edit/:id",
        exact: true,
        component: lazy(() => import("views/User/Edit")),
      },
      {
        path: "/acesso_negado",
        exact: true,
        component: lazy(() => import("views/ProhibitedAccess")),
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ],
  },
];

export default routes;
